export default __webpack_public_path__ + "static/partnerIcon7-8568d6803cef0790c6f9d6a823f5d7e8.svg";